import type { RootState } from '@core/core/store'

import { survey2dAdapter } from './survey2dSlice'

export const { selectAll: selectAllSurvey2ds } = survey2dAdapter.getSelectors<RootState>(
  state => state.surveys2ds,
)
